const Quotation = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.13525 4.18555H13.6885V7.44482C13.6885 8.00635 13.6112 8.5516 13.4565 9.08057C13.3101 9.6014 13.0578 10.0693 12.6997 10.4844C12.3416 10.8913 11.8696 11.2168 11.2837 11.4609C10.7059 11.6969 9.98975 11.8149 9.13525 11.8149V9.71533C10.1037 9.71533 10.7669 9.50781 11.125 9.09277C11.4831 8.67773 11.6621 8.12842 11.6621 7.44482V7.26172H9.13525V4.18555ZM2.31152 4.18555H6.86475V7.44482C6.86475 8.00635 6.78744 8.5516 6.63281 9.08057C6.48633 9.6014 6.23405 10.0693 5.87598 10.4844C5.5179 10.8913 5.0459 11.2168 4.45996 11.4609C3.87402 11.6969 3.15788 11.8149 2.31152 11.8149V9.71533C3.27995 9.71533 3.9432 9.50781 4.30127 9.09277C4.65934 8.67773 4.83838 8.12842 4.83838 7.44482V7.26172H2.31152V4.18555Z"
      fill="white"
    />
  </svg>
);

export default Quotation;
